module.exports = __webpack_public_path__ + "img/img-04.729db377.png";